import React, { useRef } from 'react'
import { IconClose, IconArrowOutlineDown } from 'components/Zui/Icon'
import { useToggle, useOnClickOutside } from 'hooks'
import { Pill, ScrollableDirective } from 'components/Zui'
import './index.css'

const Index = ({ data, handleDeleteMailPill }) => {
    const { isOpen, onToggle, onClose } = useToggle()
    const myRef = useRef(null)
    useOnClickOutside(myRef, onClose, 'mailPills')
    return (
        <>
            {data?.length > 0 && (
                <div className="mail-share-pill-item-wrapper" data-ref="mailPills">
                    {data.slice(0, 3).map(user => {
                        return (
                            <div className="mail-share-pill-item" key={user.email}>
                                <Pill closable onClose={() => handleDeleteMailPill(user.email)}>
                                    {user.email}
                                </Pill>
                            </div>
                        )
                    })}
                </div>
            )}

            {data?.length > 3 && (
                <Pill>
                    <div className="multi-pill-wrapper">
                        <div className="multi-option-pill">
                            <span>+{data.length - 3}</span>
                            <div className="pill-open-icon">
                                <IconArrowOutlineDown size="s" onClick={onToggle} />
                            </div>
                        </div>
                        {isOpen && (
                            <div className="pill-options-wrapper">
                                <ScrollableDirective
                                    style={{
                                        maxHeight: '128px',
                                    }}
                                >
                                    {data.slice(3).map(user => (
                                        <div key={user.email} className="pill-item-wrapper">
                                            <span className="maildropdown">{user.email}</span>
                                            <span>
                                                <IconClose
                                                    size="s"
                                                    onClick={() => handleDeleteMailPill(user.email)}
                                                />
                                            </span>
                                        </div>
                                    ))}
                                </ScrollableDirective>
                            </div>
                        )}
                    </div>
                </Pill>
            )}
        </>
    )
}

export default Index
